import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

export const byAuthCodeGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthenticationService);
  /* step 1: Are they authenticated? */
  let isAuthenticated = (!authService.setUser() && !authService.getUser()) ? false : true;

  if(isAuthenticated){
    const roles = authService.getRoles();
    const isAuthenticated: boolean = roles !== null && roles.length > 0;
    const hasAgreedToTerms = authService.getHasAgreedToTerms();
    const isCsr = roles && roles.includes('csr_user');
    const isMc = roles && roles.includes('mc_view');
    const isTpip = roles && roles.includes('mc_request') && !roles.includes('mc_view');

    // check if user has role for dashboard
    if (!isMc) {
      if (!hasAgreedToTerms) {
        if (isTpip) { authService.setAccountType('tpip'); }
              // user has not agreed to terms and conditions
              return inject(Router).navigate(['/termsandconditions']);
          } else {
              /* step 3: the user is authorized and has agreed to terms */
              // not authorized
              return inject(Router).navigate(['/accessDenied']);
          }
      } else {
        authService.setAccountType('mah');
        /* step 2: Has the user agreed to the terms and conditions? */
        if (!hasAgreedToTerms) {
            // user has not agreed to terms and conditions
            return inject(Router).navigate(['/termsandconditions']);
        } else {
            /* step 3: the user is authorized and has agreed to terms */
            // Look for audit acknowledgement conditions
            return true;
        }
      }
  } else {
        /* step 1b: Is the user in an authorized role to see the given page? */
          // not logged in so redirect to login page with the return url
          const deepLink =  authService.getDeepLink();
          if (deepLink) {
              return inject(Router).navigate(['/signin']);
          } else {
              authService.setDeepLink('');
              return inject(Router).navigate(['/']);
          }
  }
};
